/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Services from 'services';
import actions from 'redux/actions';

export default () => {
  const { getRepliesServlet } = actions;
  const authReducer = useSelector((state) => state.authReducer);
  const token = Services.decryptToSessionId({
    name: authReducer.name,
    role: authReducer.role,
    token: authReducer.token,
  });
  const dispatch = useDispatch();
  return useEffect(() => {
    if (authReducer.isLogin) {
      dispatch(getRepliesServlet(token));
    }
  }, []);
};
